import { Icon } from "@cloudscape-design/components";


export function AIIcon() {
  return (
    <Icon name="gen-ai" />
  );
}